module.exports = __webpack_public_path__ + "static/fonts/DINProLight.f8edbcd7.woff";